<template>
  <div class="referral">
    <GroupTable />
  </div>
</template>

<script>
import GroupTable from "@/components/group/GroupTable";
export default {
  components: { GroupTable },
};
</script>
